export enum ConfidenceLevel {
    /** 50% confidence level. */
    L50 = 0.5,

    /** 70% confidence level. */
    L70 = 0.7,

    /** 75% confidence level. */
    L75 = 0.75,

    /** 80% confidence level. */
    L80 = 0.8,

    /** 85% confidence level. */
    L85 = 0.85,

    /** 90% confidence level. */
    L90 = 0.9,

    /** 92% confidence level. */
    L92 = 0.92,

    /** 95% confidence level. */
    L95 = 0.95,

    /** 96% confidence level. */
    L96 = 0.96,

    /** 97% confidence level. */
    L97 = 0.97,

    /** 98% confidence level. */
    L98 = 0.98,

    /** 99% confidence level. */
    L99 = 0.99,

    /** 99.9% confidence level. */
    L999 = 0.999,

    /** 99.99% confidence level. */
    L9999 = 0.9999,
}
